import * as R from 'ramda'
import { SET_ENTITIES } from 'actions'

const surveyEmailDeliverySetting = (state = {}, action) => {
  switch (action.type) {
    case SET_ENTITIES: {
      return R.merge(state, action.entities.surveyEmailDeliverySetting)
    }
    default:
      return state
  }
}

export default surveyEmailDeliverySetting



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/reducers/data/surveyEmailDeliverySetting.js